import { SVGProps } from 'react';

const CartPlus = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width || '28'}
      height={props?.height || '28'}
      viewBox="0 0 28 28"
      fill="none"
    >
      <g clipPath="url(#clip0_7292_12169)">
        <path
          d="M0.825317 0.820312H4.68283L6.58165 7.51674"
          stroke={props?.fill || '#14B8FA'}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.6625 27.0401C25.5968 26.6531 26.0405 25.582 25.6535 24.6477C25.2665 23.7134 24.1954 23.2697 23.261 23.6567C22.3267 24.0437 21.8831 25.1148 22.2701 26.0491C22.6571 26.9834 23.7282 27.4271 24.6625 27.0401Z"
          stroke={props?.fill || '#14B8FA'}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6348 25.7724C11.8672 24.7882 11.2577 23.8019 10.2735 23.5695C9.28926 23.3371 8.30299 23.9466 8.07059 24.9308C7.83818 25.915 8.44765 26.9013 9.43186 27.1337C10.4161 27.3661 11.4023 26.7566 11.6348 25.7724Z"
          stroke={props?.fill || '#14B8FA'}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.90421 19.9471C8.92115 19.9471 8.12418 20.744 8.12418 21.7272C8.12418 22.7102 8.9211 23.5072 9.90421 23.5072H23.9615M19.349 13.7314H14.4074M16.8782 11.2606V16.2022M6.58167 7.51562L9.87163 19.9471H23.8847L27.1747 7.51562H6.58167Z"
          stroke={props?.fill || '#14B8FA'}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7292_12169">
          <rect width={props?.width || '28'} height={props?.height || '28'} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CartPlus;
